module.exports = __webpack_public_path__ + "static/organicrainbowmain-4818d829ee87283f7eaa6f317e5d2c83.png";